import script from "./ModalConfirmForgotPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalConfirmForgotPassword.vue?vue&type=script&lang=ts&setup=true"

import "./ModalConfirmForgotPassword.vue?vue&type=style&index=0&id=f91759dc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f91759dc"]])

export default __exports__